import React, { useState } from 'react';
import { MdEmail, MdLock } from 'react-icons/md';
import { FaUserShield } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const handleSubmit_old = async (e) => {
        e.preventDefault();

        // Make an API call to the backend to validate the credentials
        try {
            const response = await fetch('https://api.glocart.in/auth/api/api/admin_login');
            const data = await response.json();

            const user = data.find((user) => user.name === email && user.password === password);

            if (user) {
                setSuccess(true);
                setError('');

                // ✅ save admin auth state
                sessionStorage.setItem("adminAuth", "true");


                setTimeout(() => {
                    navigate('/admindashboard');
                }, 1000); // Redirect to the admin dashboard after a short delay
            } else {
                setError('Invalid credentials');
                setSuccess(false);
            }
        } catch (err) {
            console.error('Error:', err);
            setError('Failed to authenticate. Please try again later.');
            setSuccess(false);
        }
    };
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(
      'https://api.glocart.in/auth/api/api/login',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      }
    );

    const data = await response.json();

    if (!response.ok) {
      setError(data.message);
      return;
    }

    sessionStorage.setItem('role', data.role);
    sessionStorage.setItem('permissions', JSON.stringify(data.permissions));
    localStorage.setItem('adminAuth', 'true');

    navigate('/admindashboard');

  } catch (err) {
    setError('Login failed');
  }
};

    return (
        <div style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}>
            <form style={{ backgroundColor: 'white', padding: '40px 30px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)', width: '350px', display: 'flex', flexDirection: 'column', alignItems: 'center' }} onSubmit={handleSubmit}>
                <div style={{ fontSize: '40px', color: '#667eea', marginBottom: '10px' }}>
                    <FaUserShield />
                </div>
                <h2 style={{ textAlign: 'center', color: '#333', margin: '10px 0 5px' }}>Admin Portal</h2>
                <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px', textAlign: 'center' }}>Sign in to manage your dashboard</p>

                {error && <div style={{ color: 'red', marginBottom: '10px', textAlign: 'center' }}>{error}</div>}
                {success && <div style={{ color: 'green', marginBottom: '10px', textAlign: 'center' }}>Login successful!</div>}

                <div style={{ display: 'flex', alignItems: 'center', width: '100%', border: '1px solid #ccc', borderRadius: '5px', marginBottom: '15px', padding: '10px', background: '#f9f9f9' }}>
                    <MdEmail style={{ marginRight: '10px', color: '#667eea', fontSize: '18px' }} />
                    <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ flex: 1, border: 'none', outline: 'none', fontSize: '16px', background: 'transparent' }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', width: '100%', border: '1px solid #ccc', borderRadius: '5px', marginBottom: '15px', padding: '10px', background: '#f9f9f9' }}>
                    <MdLock style={{ marginRight: '10px', color: '#667eea', fontSize: '18px' }} />
                    <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{ flex: 1, border: 'none', outline: 'none', fontSize: '16px', background: 'transparent' }} />
                </div>

                <button type="submit" style={{ width: '100%', padding: '12px', backgroundColor: '#667eea', border: 'none', color: 'white', fontSize: '16px', borderRadius: '5px', cursor: 'pointer', transition: 'background 0.3s ease', marginTop: '10px' }}>Login</button>
            </form>
        </div>
    );
};

export default Login;
